<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listado" :items-per-page="20">
      <template v-slot:[`item.fechaNombramiento`]="{ item }">
        {{ $moment(item.fechaNombramiento).format('D-MM-YYYY') }}
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :funcionario="item"></opciones>
      </template>
      <template v-slot:[`item.esSupervisor`]="{ item }">
        <v-icon
          v-if="item.esSupervisor"
          class="amber--text">
          fa-hard-hat
        </v-icon>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoFuncionariosDesktop',
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Nombre',
          align: 'start',
          value: 'nombre',
        },
        { text: 'Puesto', value: 'puesto' },
        { text: 'F. Nombramiento', value: 'fechaNombramiento' },
        { text: 'Supervisor', value: 'esSupervisor' },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
</style>
